module.exports = __webpack_public_path__ + "img/swap_horiz_opsz20.1d2fcd0b.svg";